<template>
  <section
    id="register"
    class="l-register"
  >
    <div class="o-container">
      <h2 class="l-register__title">
        primeiro, o cadastro
      </h2>

      <p class="l-register__description">
        você vai precisar de um

        <span v-if="showRegisterLink">
          <a
            :href="userRegisterPath"
          > cadastro </a></span>

        <span v-else> cadastro </span>
        provando que não é um robô viciado em compras.
      </p>

      <div class="o-grid -xs-middle -xs-full -xs-between">
        <div class="o-grid__item l-register__wrapper -xs-24 -md-11">
          <img
            class="l-register__image"
            :src="`${require('@@/assets/images/landing-pages/how-to-buy/register/brands.png')}`"
            alt="Imagem reunindo em círculos as logos de diversas marcas encontradas no enjoei."
          >
        </div>

        <div class="o-grid__item l-register__grid -xs-24 -md-13">
          <div class="l-register__content">
            <h2 class="title l-register__content-title">
              mais de cinco milhões <span class="t-xs-block t-md-inline">de enjoos</span>
            </h2>

            <p class="l-register__content-description">
              navegue pela nossa página, veja marcas como adidas, apple, farm,
              melissa, schutz, zara com ofertas e promoções especialíssimas no
              nosso app.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import STORE_TYPES_SESSION from '@/web/store/registered/session'
  import getPath from '@/tools/get-path'

  export default {
    data() {
      return {
        showRegisterLink: false
      }
    },
    computed: {
      ...mapGetters({
        isSignedIn: STORE_TYPES_SESSION.GETTERS.GET_IS_SIGNED_IN
      }),
      userRegisterPath() {
        return getPath('new-user-register')
      }
    },
    watch: {
      isSignedIn: {
        handler() {
          this.showRegisterLink = !this.isSignedIn
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .l-register {
    padding: 0 20px;
    margin-top: 88px;
    text-align: left;

    @include breakpoint(md) {
      margin-top: 64px;
      margin: 152px auto 40px;
      text-align: center;
    }

    &__title {
      font-weight: $font-weight-extra-bold;
      font-size: 28px;
      line-height: 32px;

      @include breakpoint(md) {
        font-size: 40px;
        line-height: 44px;
      }
    }

    &__description {
      line-height: 24px;
      margin: 24px auto 64px;

      @include breakpoint(md) {
        margin: 32px auto 128px;
        color: $color-text-extra-dark;
        font-size: 20px;
        max-width: 90%;
      }
    }

    &__content {
      text-align: left;

      @include breakpoint(md) {
        max-width: 80%;
        margin-left: 30px;
      }

      &-title {
        font-size: 28px;
        margin: 24px 0;
        font-weight: $font-weight-extra-bold;
        line-height: 32px;

        @include breakpoint(md) {
          font-size: 40px;
          line-height: 44px;
          margin: 0;
        }
      }

      &-description {
        margin: 24px auto 0;
        line-height: 24px;

        @include breakpoint(md) {
          margin: 32px auto 0;
        }
      }
    }

    &__grid {
      order: 1;
      @include breakpoint(md) {
        order: 2;
      }
    }

    &__wrapper {
      display: flex;
      justify-content: center;
      order: 2;
      margin-top: 32px;

      @include breakpoint(md) {
        margin: 0;
        order: 1;
      }
    }

    &__image {
      width: 100%;
      height: 100%;
      max-width: 335px;

      @include breakpoint(md) {
        max-width: 500px;
        width: 100%;
        height: auto;
      }
    }
  }

  .o-container {
    max-width: 1067px;
  }
</style>
